// Small text-formatting helpers shared across pages.

// Title-cases a name/surname, e.g. "john  VAN dyk" -> "John  Van Dyk".
export function titleCase(str) {
  if (!str) return "";
  return str
    .trim()
    .split(/\s+/)
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(" ");
}
